import React from 'react'
import { Box, Card, CardContent, Typography } from '@mui/material'
import { blueGrey, grey } from '@mui/material/colors'
import ComparisonBadge from './ComparisonBadge'

export default function KPICard({ title, value, unit, change, invertColors = false }) {
  return (
    <Card sx={{
      minWidth: 180,
      m: 1,
      bgcolor: blueGrey[900],
      boxShadow: 3,
    }}>
      <CardContent sx={{ textAlign: 'center', py: 2 }}>
        <Typography variant="caption" sx={{ color: grey[400], textTransform: 'uppercase', letterSpacing: 1 }}>
          {title}
        </Typography>
        <Box display="flex" justifyContent="center" alignItems="baseline" gap={0.5} mt={1}>
          <Typography variant="h4" sx={{ color: grey[100], fontWeight: 700 }}>
            {value ?? '--'}
          </Typography>
          {unit && (
            <Typography variant="body2" sx={{ color: grey[400] }}>
              {unit}
            </Typography>
          )}
        </Box>
        {change !== undefined && change !== null && (
          <Box mt={0.5} display="flex" justifyContent="center">
            <ComparisonBadge value={change} invertColors={invertColors} />
          </Box>
        )}
      </CardContent>
    </Card>
  )
}
